import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import LensPost from './LensPost/LensPost';
import SharePost from './SharePost';
import DeletePost from './DeletePost';
import ReportPost from './ReportComment/ReportComment';
import ReportComment from './ReportComment/ReportComment';

function Modal() {
    const activeModal = useSelector((state) => state.lens.modal.activeModal);
    const displayModal = useSelector((state) => state.lens.modal.displayModal);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if(displayModal) {
            setVisible(true);
        } else {
            setVisible(false);
        }
    }, [displayModal]);

    return (
        <div className={`${visible ? 'opacity-100 visible bg-[#00000080]' : 'opacity-0 invisible'} transition-all duration-100 ease-in-out fixed z-50 size-full top-0 left-0 flex justify-center items-center`}>
            {activeModal === 'post' && <LensPost />}

            {activeModal === 'share' && <SharePost />}

            {activeModal === 'delete' && <DeletePost />}

            {activeModal === 'report-post' && <ReportPost />}

            {activeModal === 'report-comment' && <ReportComment />}
        </div>
    );
}

export default Modal;
